import { useContext, useState, useEffect } from "react";
import Post from "../post/Post";
import Share from "../share/Share";
import "./feed.css";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
// import { useSnackbar } from "notistack"
// import { useOnlineStatus } from "../hooks/useOnlineStatus";

export default function Feed({ username, page}) {
  const [posts, setPosts] = useState([]);
  const { user } = useContext(AuthContext);
  // const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  // const isOnline = useOnlineStatus();

  // useEffect(() => {
  //   if (isOnline) {
  //     enqueueSnackbar("You are online", {
  //       variant: "success",
  //       autoHideDuration: 2000,
  //     });
  //     const onlineStatus = axios.put("http://localhost:8800/api/users/online/" + user._id, { isOnline: true })
  //   } else {
  //     enqueueSnackbar("You are offline", {
  //       variant: "error",
  //       autoHideDuration: 2000,
  //     });
  //     const onlineStatus = axios.put("http://localhost:8800/api/users/online/" + user._id, { isOnline: false })
  //   }
  // }, [isOnline]);

  useEffect(() => {
    const fetchPosts = async () => {
      const res = username
        ? await axios.get("https://conexus-api.vercel.app/api/posts/profile/" + username)
        : await axios.get("https://conexus-api.vercel.app/api/posts/timeline/" + user._id);
      setPosts(
        res.data.sort((p1, p2) => {
          return new Date(p2.createdAt) - new Date(p1.createdAt);
        })
      )
    };
    fetchPosts();
  }, [username, user._id]);

  return (
    <div className="feed">
        <div className="feedWrapper">
          {page === undefined && <Share />}
          {posts.map((p) => (
            <Post key={p._id} post={p} />
          ))}
        </div>
    </div>
  );
}
